import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Flex } from 'pcln-design-system'
import NavLink from '../NavLink'
import NavDropdown from '../NavDropdown'
import alignmentToJustify from '../../utils/alignmentToJustify'
import { headerNavigationShape, alignmentTypes } from '../../utils/shapes'

const Nav = styled.nav`
  display: flex;
  width: 100%;
  max-width: 1440px;
  height: 100%;

  margin: 0 ${themeGet('space.4')}px;
`
Nav.displayName = 'Nav'

const Content = styled(Flex)`
  position: relative;
  align-items: center;
  width: 100%;
`
Content.displayName = 'Content'

const LinksContainer = styled(Flex)`
  display: flex;
  width: 100%;
  position: relative;
  justify-content: ${props => props.justifyContent};
  white-space: nowrap;

  > * {
    display: flex;
    align-items: center;
    margin-right: ${themeGet('space.4')}px;
  }
`
LinksContainer.displayName = 'LinksContainer'

function Navigation ({
  className,
  navigation,
  target,
  color,
  iconColor,
  dropdownColor,
  align,
  activeNavLink
}) {
  const justifyContent = alignmentToJustify(align)

  return (
    <Nav>
      {navigation.length > 0 && (
        <Content id='primary-nav'>
          <LinksContainer
            id='global-header-nav-section'
            data-testid='nav-links-container'
            justifyContent={justifyContent}
            center={align === 'center'}
          >
            {navigation.map(link => {
              if (link.isMobileOnly) {
                return null
              }

              return link.links && link.links.length > 0 ? (
                <NavDropdown
                  key={link.label}
                  label={link.label}
                  target={target}
                  color={color}
                  iconColor={iconColor}
                  backgroundColor={dropdownColor}
                  links={link.links}
                />
              ) : (
                <NavLink
                  key={link.label}
                  label={link.label}
                  href={link.href}
                  target={target}
                  color={activeNavLink === link.label ? 'primary' : color}
                  fontWeight={activeNavLink === link.label ? '900' : '500'}
                  iconColor={iconColor}
                  links={link.links}
                />
              )
            })}
          </LinksContainer>
        </Content>
      )}
    </Nav>
  )
}

Navigation.displayName = 'Navigation'

Navigation.propTypes = {
  className: PropTypes.string,
  navigation: PropTypes.arrayOf(headerNavigationShape).isRequired,
  target: PropTypes.string,
  color: PropTypes.string,
  iconColor: PropTypes.string,
  dropdownColor: PropTypes.string,
  align: alignmentTypes,
  activeNavLink: PropTypes.string
}

Navigation.defaultProps = {
  className: '',
  align: 'center'
}

export default memo(Navigation)
